import React, { useState } from "react";
import "./WatchStation.css";
import watch1 from "../../../image/watch/watch1.png";
import watch2 from "../../../image/watch/watch2.png";
import watch3 from "../../../image/watch/watch3.png";
import watch4 from "../../../image/watch/watch4.png";
import watch5 from "../../../image/watch/watch5.png";
import watch6 from "../../../image/watch/watch6.png";
import watch7 from "../../../image/watch/watch7.png";
import watch8 from "../../../image/watch/watch8.png";
import watch9 from "../../../image/watch/watch9.png";
import watch10 from "../../../image/watch/watch10.png";
import watch11 from "../../../image/watch/watch11.png";
import watch12 from "../../../image/watch/watch12.png";
import watch13 from "../../../image/watch/watch13.png";
import watch14 from "../../../image/watch/watch14.png";
import { HiOutlineX } from "react-icons/hi";

const WatchStationGallery = () => {
  let data = [
    {
      id: 1,
      imgSrc: watch1,
      title: "Homepage 1",
    },
    {
      id: 2,
      imgSrc: watch2,
      title: "Homepage 2",
    },
    {
      id: 3,
      imgSrc: watch3,
      title: "Store",
    },
    {
      id: 4,
      imgSrc: watch4,
      title: "Purchase",
    },
    {
      id: 5,
      imgSrc: watch5,
      title: "Support 1",
    },
    {
      id: 6,
      imgSrc: watch6,
      title: "Support 2",
    },
    {
      id: 7,
      imgSrc: watch7,
      title: "Support 3",
    },
    {
      id: 8,
      imgSrc: watch8,
      title: "Login",
    },
    {
      id: 9,
      imgSrc: watch9,
      title: "Users orders dashboard",
    },
    {
      id: 10,
      imgSrc: watch10,
      title: "Payment gateway",
    },
    {
      id: 11,
      imgSrc: watch11,
      title: "Review",
    },
    {
      id: 12,
      imgSrc: watch12,
      title: "Add products (Admin Dashboard)",
    },
    {
      id: 13,
      imgSrc: watch13,
      title: "Manage orders (Admin Dashboard)",
    },
    {
      id: 14,
      imgSrc: watch14,
      title: "Manage products (Admin Dashboard",
    },
  ];

  const [model, setModel] = useState(false);
  const [tempImgSrc, setTempImgSrc] = useState("false");

  const getImg = (imgSrc) => {
    setTempImgSrc(imgSrc);
    setModel(true);
  };

  return (
    <>
      <div
        className={model ? "model open" : "model"}
        onClick={() => setModel(false)}
      >
        <img src={tempImgSrc} alt="expand" />
        <HiOutlineX onClick={() => setModel(false)} />
      </div>
      <div className="gallery">
        {data.map((item, index) => {
          return (
            <div
              className="pics"
              key={index}
              onClick={() => getImg(item.imgSrc)}
            >
              <img
                src={item.imgSrc}
                alt={item.title}
                style={{ width: "100%" }}
              />
              {/* <p>{item.title}</p> */}
            </div>
          );
        })}
      </div>
      ;
    </>
  );
};

export default WatchStationGallery;
